"use strict";

var moduleName = "responsive-table";


module.exports = function () {
	$(".jsResponsiveTable").each(function () {
		if($.data(this, moduleName + "-init")) return;
		$.data(this, moduleName + "-init", true);

		var $table = $(this),
			titles = $table.find("thead th").get().map(item => $(item).text());

		$table.find("tbody tr").each(function (i, tr) {
			$(tr).find("td").each(function (j, td) {
				$(td).attr("data-title", titles[j]);
			})
		});
	});
};





/** WEBPACK FOOTER **
 ** D:/phpstorm/szar/src/js/modules/responsiveTableInit.js
 **/